// Toggle profile edit mode
window.toggleProfileEdit = function() {
	var fields = document.querySelectorAll('.profile-field');
	var submitWrap = document.getElementById('rcp_profile_submit_wrap');
	var editBtn = document.querySelector('.member-edit-btn');
	
	if (!fields || fields.length === 0) {
		return;
	}
	
	var isEditing = !fields[0].disabled;
	
	if (isEditing) {
		// Disable editing
		fields.forEach(function(field) {
			field.disabled = true;
		});
		// Disable multiselect wrappers
		var multiselectWrappers = document.querySelectorAll('.rcp-multiselect-wrapper, .rcp_demographic-wrapper, .rcp_country-wrapper');
		multiselectWrappers.forEach(function(wrapper) {
			wrapper.classList.add('disabled');
		});
		if (submitWrap) {
			submitWrap.style.display = 'none';
		}
		if (editBtn) {
			editBtn.textContent = 'Edit information';
		}
	} else {
		// Enable editing
		fields.forEach(function(field) {
			field.disabled = false;
		});
		// Enable multiselect wrappers
		var multiselectWrappers = document.querySelectorAll('.rcp-multiselect-wrapper, .rcp_demographic-wrapper, .rcp_country-wrapper');
		multiselectWrappers.forEach(function(wrapper) {
			wrapper.classList.remove('disabled');
		});
		if (submitWrap) {
			submitWrap.style.display = 'block';
		}
		if (editBtn) {
			editBtn.textContent = 'Cancel';
		}
	}
	
	// Update avatar upload container state
	var avatarContainer = document.querySelector('.member-avatar-upload-container');
	var avatarRemoveBtn = document.getElementById('member_avatar_remove');
	
	if (avatarContainer) {
		if (isEditing) {
			// Disable avatar upload when not editing
			avatarContainer.classList.remove('editing-mode');
			avatarContainer.style.cursor = 'default';
			avatarContainer.style.pointerEvents = 'none';
		} else {
			// Enable avatar upload when editing
			avatarContainer.classList.add('editing-mode');
			avatarContainer.style.cursor = 'pointer';
			avatarContainer.style.pointerEvents = 'auto';
		}
	}
	
	// Update avatar remove button visibility based on current avatar and edit mode
	var avatarDisplay = document.getElementById('member_avatar_display');
	var avatarRemoveBtn = document.getElementById('member_avatar_remove');
	
	if (avatarRemoveBtn && avatarDisplay) {
		// Check if user has a custom avatar (not initials, not default Gravatar)
		var hasAvatar = checkIfHasCustomAvatar(avatarDisplay);
		
		// Show remove button only when editing AND user has custom avatar
		if (!isEditing && hasAvatar) {
			avatarRemoveBtn.style.display = 'block';
		} else {
			avatarRemoveBtn.style.display = 'none';
		}
	}
};

// Helper function to check if user has custom avatar
function checkIfHasCustomAvatar(avatarDisplay) {
	if (!avatarDisplay) {
		return false;
	}
	
	var hasAvatar = false;
	var avatarImg = null;
	var initialsDiv = avatarDisplay.querySelector('.member-avatar-initials');
	
	// If there are initials, no custom avatar
	if (initialsDiv) {
		return false;
	}
	
	// Check if avatarDisplay itself is an img element (when custom avatar is loaded)
	if (avatarDisplay.tagName === 'IMG') {
		avatarImg = avatarDisplay;
	} else {
		// Otherwise, look for img inside
		avatarImg = avatarDisplay.querySelector('img');
	}
	
	if (avatarImg) {
		// Check if it's a custom uploaded avatar (from wp-content/uploads)
		var imgSrc = avatarImg.src || '';
		// Check for custom uploads, data URLs (preview)
		hasAvatar = imgSrc && (
			imgSrc.includes('wp-content/uploads') || 
			imgSrc.includes('data:')
		);
		
		// Also check if it's not a default Gravatar (but only if it's not already identified as custom)
		if (!hasAvatar && imgSrc) {
			hasAvatar = !imgSrc.includes('gravatar.com/avatar/') && 
			            !imgSrc.includes('mystery') && 
			            !imgSrc.includes('blank') &&
			            !imgSrc.includes('identicon') &&
			            !imgSrc.includes('monsterid') &&
			            !imgSrc.includes('wavatar') &&
			            !imgSrc.includes('retro');
		}
	}
	
	return hasAvatar;
};

// Sync visible fields with hidden fields and ensure values are submitted
(function() {
	// Sync function that copies value from visible to hidden field
	function syncFieldsBeforeSubmit() {
		var demographicSelect = document.getElementById('rcp_demographic');
		var countrySelect = document.getElementById('rcp_country');
		var demographicHidden = document.getElementById('rcp_demographic_hidden');
		var countryHidden = document.getElementById('rcp_country_hidden');
		
		if (demographicSelect && demographicHidden) {
			var selected = Array.from(demographicSelect.selectedOptions).map(function(option) {
				return option.value;
			});
			demographicHidden.value = selected.join(',');
		}
		
		if (countrySelect && countryHidden) {
			countryHidden.value = countrySelect.value || '';
		}
	}
	
	// Setup form submit handler
	function setupFormSubmitHandler() {
		var profileForm = document.getElementById('rcp_profile_editor_form');
		if (profileForm) {
			// Remove existing listener if any
			profileForm.removeEventListener('submit', handleFormSubmit);
			
			// Add submit handler
			profileForm.addEventListener('submit', handleFormSubmit, true);
		}
	}
	
	// Form submit handler
	function handleFormSubmit(e) {
		// Sync hidden fields before submission
		syncFieldsBeforeSubmit();
		
		// Enable all profile fields before submission
		var fields = document.querySelectorAll('.profile-field');
		fields.forEach(function(field) {
			field.disabled = false;
		});
	}
	
	// Setup multiselect for demographic field
	function setupDemographicMultiselect() {
		var searchInput = document.getElementById('rcp_demographic_search');
		var selectField = document.getElementById('rcp_demographic');
		var selectedDiv = document.getElementById('rcp_demographic_selected');
		var hiddenField = document.getElementById('rcp_demographic_hidden');
		
		if (!searchInput || !selectField || !selectedDiv || !hiddenField) {
			return;
		}
		
		// Check if already initialized
		if (searchInput.dataset.demographicMultiselectInitialized === 'true') {
			return;
		}
		
		// Mark as initialized
		searchInput.dataset.demographicMultiselectInitialized = 'true';
		
		var dropdown = null;
		var dropdownVisible = false;
		
		// Function to remove all existing dropdowns (in case of multiple initializations)
		function removeAllDropdowns() {
			var wrapper = searchInput.closest('.rcp_demographic-wrapper');
			if (wrapper) {
				var existingDropdowns = wrapper.querySelectorAll('.rcp-multiselect-dropdown');
				existingDropdowns.forEach(function(dd) {
					dd.remove();
				});
			}
		}
		
		// Function to update selected display
		function updateSelectedDisplay() {
			var selected = Array.from(selectField.selectedOptions);
			selectedDiv.innerHTML = '';
			
			// Add tags for selected options
			selected.forEach(function(option) {
				var tag = document.createElement('span');
				tag.className = 'rcp-multiselect-tag';
				tag.textContent = option.textContent;
				var removeBtn = document.createElement('span');
				removeBtn.className = 'rcp-multiselect-remove';
				removeBtn.textContent = ' ×';
				removeBtn.onclick = function(e) {
					e.stopPropagation();
					option.selected = false;
					updateSelectedDisplay();
					updateHiddenField();
					renderDropdown();
				};
				tag.appendChild(removeBtn);
				selectedDiv.appendChild(tag);
			});
			
			// Update placeholder - show only when no selections and input is empty
			if (selected.length > 0 || searchInput.value.length > 0) {
				searchInput.placeholder = '';
			} else {
				searchInput.placeholder = 'Search options...';
			}
		}
		
		// Function to update hidden field
		function updateHiddenField() {
			var selected = Array.from(selectField.selectedOptions).map(function(option) {
				return option.value;
			});
			hiddenField.value = selected.join(',');
		}
		
		// Function to render dropdown
		function renderDropdown() {
			// Remove all existing dropdowns first
			removeAllDropdowns();
			if (dropdown) {
				dropdown.remove();
				dropdown = null;
			}
			
			dropdown = document.createElement('div');
			dropdown.className = 'rcp-multiselect-dropdown';
			
			var searchTerm = searchInput.value.toLowerCase();
			var options = selectField.options;
			
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				var text = option.textContent.toLowerCase();
				
				if (searchTerm === '' || text.indexOf(searchTerm) !== -1) {
					var item = document.createElement('div');
					item.className = 'rcp-multiselect-option';
					if (option.selected) {
						item.classList.add('selected');
					}
					item.textContent = option.textContent;
					
					(function(opt) {
						item.onclick = function(e) {
							e.stopPropagation();
							opt.selected = !opt.selected;
							// Clear search input after selection
							searchInput.value = '';
							updateSelectedDisplay();
							updateHiddenField();
							renderDropdown();
							// Keep focus on search input for next selection
							searchInput.focus();
						};
					})(option);
					
					dropdown.appendChild(item);
				}
			}
			
			var wrapper = searchInput.closest('.rcp_demographic-wrapper');
			if (wrapper) {
				wrapper.style.position = 'relative';
				wrapper.appendChild(dropdown);
				dropdownVisible = true;
			}
		}
		
		function hideDropdown() {
			// Remove all dropdowns, not just the current one
			removeAllDropdowns();
			if (dropdown) {
				dropdown.remove();
				dropdown = null;
				dropdownVisible = false;
			}
		}
		
		// Initial cleanup
		removeAllDropdowns();
		
		// Search input events
		searchInput.addEventListener('input', function() {
			// Update placeholder when typing
			if (this.value.length > 0) {
				this.placeholder = '';
			} else {
				var selected = Array.from(selectField.selectedOptions);
				if (selected.length === 0) {
					this.placeholder = 'Search options...';
				}
			}
			renderDropdown();
		});
		
		searchInput.addEventListener('focus', function() {
			renderDropdown();
		});
		
		searchInput.addEventListener('blur', function() {
			// Restore placeholder if no selections and input is empty
			setTimeout(function() {
				if (searchInput.value.length === 0) {
					var selected = Array.from(selectField.selectedOptions);
					if (selected.length === 0) {
						searchInput.placeholder = 'Search options...';
					}
				}
			}, 200); // Delay to allow click events on dropdown
		});
		
		// Close dropdown when clicking outside
		document.addEventListener('click', function(e) {
			if (searchInput && !searchInput.contains(e.target) && 
				(!dropdown || !dropdown.contains(e.target)) &&
				(!selectedDiv || !selectedDiv.contains(e.target))) {
				hideDropdown();
			}
		});
		
		// Select field change events
		selectField.addEventListener('change', function() {
			updateSelectedDisplay();
			updateHiddenField();
		});
		
		// Initial cleanup and display
		removeAllDropdowns();
		updateSelectedDisplay();
		updateHiddenField();
	}
	
	// Setup custom dropdown for country field
	function setupCountryDropdown() {
		var searchInput = document.getElementById('rcp_country_search');
		var selectField = document.getElementById('rcp_country');
		var selectedDiv = document.getElementById('rcp_country_selected');
		var hiddenField = document.getElementById('rcp_country_hidden');
		
		if (!searchInput || !selectField || !selectedDiv || !hiddenField) {
			return;
		}
		
		// Check if already initialized
		if (searchInput.dataset.countryDropdownInitialized === 'true') {
			return;
		}
		
		// Mark as initialized
		searchInput.dataset.countryDropdownInitialized = 'true';
		
		var dropdown = null;
		var dropdownVisible = false;
		
		// Function to remove all existing dropdowns (in case of multiple initializations)
		function removeAllDropdowns() {
			var wrapper = searchInput.closest('.rcp_country-wrapper');
			if (wrapper) {
				var existingDropdowns = wrapper.querySelectorAll('.rcp-multiselect-dropdown');
				existingDropdowns.forEach(function(dd) {
					dd.remove();
				});
			}
		}
		
		// Function to update selected display
		function updateSelectedDisplay() {
			var selectedOption = selectField.options[selectField.selectedIndex];
			selectedDiv.innerHTML = '';
			
			if (selectedOption && selectedOption.value !== '') {
				var valueSpan = document.createElement('span');
				valueSpan.className = 'rcp-country-value';
				valueSpan.textContent = selectedOption.textContent;
				selectedDiv.appendChild(valueSpan);
				searchInput.placeholder = '';
			} else {
				searchInput.placeholder = 'Select country...';
			}
		}
		
		// Function to update hidden field
		function updateHiddenField() {
			hiddenField.value = selectField.value || '';
		}
		
		// Function to render dropdown
		function renderDropdown() {
			// Remove all existing dropdowns first
			removeAllDropdowns();
			if (dropdown) {
				dropdown.remove();
				dropdown = null;
			}
			
			dropdown = document.createElement('div');
			dropdown.className = 'rcp-multiselect-dropdown';
			
			var searchTerm = searchInput.value.toLowerCase();
			var options = selectField.options;
			
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				var text = option.textContent.toLowerCase();
				
				if (searchTerm === '' || text.indexOf(searchTerm) !== -1) {
					var item = document.createElement('div');
					item.className = 'rcp-multiselect-option';
					if (option.selected && option.value !== '') {
						item.classList.add('selected');
					}
					item.textContent = option.textContent;
					
					(function(opt) {
						item.onclick = function(e) {
							e.stopPropagation();
							// Deselect all options first
							for (var j = 0; j < selectField.options.length; j++) {
								selectField.options[j].selected = false;
							}
							// Select clicked option
							opt.selected = true;
							// Clear search input after selection
							searchInput.value = '';
							updateSelectedDisplay();
							updateHiddenField();
							hideDropdown();
						};
					})(option);
					
					dropdown.appendChild(item);
				}
			}
			
			var wrapper = searchInput.closest('.rcp_country-wrapper');
			if (wrapper) {
				wrapper.style.position = 'relative';
				wrapper.appendChild(dropdown);
				dropdownVisible = true;
			}
		}
		
		function hideDropdown() {
			// Remove all dropdowns, not just the current one
			removeAllDropdowns();
			if (dropdown) {
				dropdown.remove();
				dropdown = null;
				dropdownVisible = false;
			}
		}
		
		// Search input events
		searchInput.addEventListener('input', function() {
			renderDropdown();
		});
		
		searchInput.addEventListener('focus', function() {
			renderDropdown();
		});
		
		// Close dropdown when clicking outside
		document.addEventListener('click', function(e) {
			if (searchInput && !searchInput.contains(e.target) && 
				(!dropdown || !dropdown.contains(e.target)) &&
				(!selectedDiv || !selectedDiv.contains(e.target))) {
				hideDropdown();
			}
		});
		
		// Select field change events
		selectField.addEventListener('change', function() {
			updateSelectedDisplay();
			updateHiddenField();
		});
		
		// Initial cleanup and display
		removeAllDropdowns();
		updateSelectedDisplay();
		updateHiddenField();
	}
	
	// Sync on field changes (for other fields)
	function setupFieldSync() {
		// This function is now mainly for other fields if needed
	}
	
	function initProfileFields() {
		setupDemographicMultiselect();
		setupCountryDropdown();
		setupFieldSync();
		setupFormSubmitHandler();
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initProfileFields);
	} else {
		initProfileFields();
	}
	
	// Retry after delay in case form loads dynamically
	setTimeout(initProfileFields, 500);
	setTimeout(initProfileFields, 1000);
})();

// Member avatar upload
(function() {
	document.addEventListener('DOMContentLoaded', function() {
		var avatarContainer = document.querySelector('.member-avatar-upload-container');
		var avatarInput = document.getElementById('member_user_avatar');
		var avatarForm = document.getElementById('member_avatar_upload_form');
		var avatarDisplay = document.getElementById('member_avatar_display');
		var avatarOverlay = document.getElementById('member_avatar_upload_overlay');
		var avatarRemoveBtn = document.getElementById('member_avatar_remove');
		
		if (!avatarContainer || !avatarInput) {
			return;
		}
		
		// Initially disable avatar upload (not in edit mode)
		avatarContainer.style.cursor = 'default';
		avatarContainer.style.pointerEvents = 'none';
		
		// Initially hide remove button (not in edit mode)
		if (avatarRemoveBtn) {
			avatarRemoveBtn.style.display = 'none';
		}
		
		// Click to upload (only when in edit mode)
		avatarContainer.addEventListener('click', function(e) {
			// Don't trigger if clicking remove button
			if (avatarRemoveBtn && (e.target === avatarRemoveBtn || avatarRemoveBtn.contains(e.target))) {
				return;
			}
			
			// Only allow upload when in editing mode
			if (!avatarContainer.classList.contains('editing-mode')) {
				return;
			}
			
			avatarInput.click();
		});
		
		// Handle file selection
		avatarInput.addEventListener('change', function(e) {
			var file = e.target.files[0];
			if (!file) {
				return;
			}
			
			// Validate file type
			if (!file.type.match('image.*')) {
				alert('Please select an image file.');
				avatarInput.value = '';
				return;
			}
			
			// Validate file size (max 5MB)
			if (file.size > 5 * 1024 * 1024) {
				alert('File is too large. Maximum size: 5MB.');
				avatarInput.value = '';
				return;
			}
			
			// Show preview immediately
			var reader = new FileReader();
			reader.onload = function(event) {
				// Create or update preview image
				var previewImg = avatarDisplay.querySelector('img');
				if (!previewImg) {
					// If it's initials or gravatar, replace with img
					var newImg = document.createElement('img');
					newImg.className = 'member-avatar';
					newImg.alt = 'Avatar preview';
					avatarDisplay.innerHTML = '';
					avatarDisplay.appendChild(newImg);
					previewImg = newImg;
				}
				previewImg.src = event.target.result;
				
				// Show remove button
				if (avatarRemoveBtn) {
					avatarRemoveBtn.style.display = 'block';
				}
			};
			reader.onerror = function() {
				alert('Error reading file.');
				avatarInput.value = '';
			};
			reader.readAsDataURL(file);
			
			// Show loading state
			if (avatarOverlay) {
				var uploadText = avatarOverlay.querySelector('.member-avatar-upload-text');
				if (uploadText) {
					uploadText.textContent = 'Uploading...';
				}
				avatarOverlay.style.display = 'flex';
			}
			
			// Upload file via AJAX
			var formData = new FormData(avatarForm);
			formData.append('action', 'upload_member_avatar');
			
			var xhr = new XMLHttpRequest();
			var ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxurl) ? themeData.ajaxurl : ((typeof ajaxurl !== 'undefined') ? ajaxurl : '/wp-admin/admin-ajax.php');
			xhr.open('POST', ajaxUrl, true);
			
			xhr.onload = function() {
				if (avatarOverlay) {
					var uploadText = avatarOverlay.querySelector('.member-avatar-upload-text');
					if (uploadText) {
						uploadText.textContent = 'Click to upload photo';
					}
				}
				
				if (xhr.status === 200) {
					try {
						var response = JSON.parse(xhr.responseText);
						if (response.success) {
							// Reload page to show new avatar
							window.location.reload();
						} else {
							alert(response.data && response.data.message ? response.data.message : (response.data || 'Error uploading photo.'));
							avatarInput.value = '';
							// Restore original display if needed
							if (avatarDisplay && !avatarDisplay.querySelector('img')) {
								// This shouldn't happen, but just in case
							}
						}
					} catch (e) {
						// If response is not JSON, might be redirect or HTML
						window.location.reload();
					}
				} else {
					alert('Error uploading photo.');
					avatarInput.value = '';
				}
			};
			
			xhr.onerror = function() {
				if (avatarOverlay) {
					var uploadText = avatarOverlay.querySelector('.member-avatar-upload-text');
					if (uploadText) {
						uploadText.textContent = 'Click to upload photo';
					}
				}
				alert('Error uploading photo.');
				avatarInput.value = '';
			};
			
			xhr.send(formData);
		});
		
		// Handle remove avatar button
		if (avatarRemoveBtn) {
			avatarRemoveBtn.addEventListener('click', function(e) {
				e.stopPropagation();
				
				// Allow removal even when not in edit mode (after saving)
				// But show confirmation
				if (!confirm('Are you sure you want to delete your profile photo?')) {
					return;
				}
				
				var formData = new FormData();
				formData.append('action', 'remove_member_avatar');
				formData.append('nonce', document.querySelector('[name="member_avatar_upload_nonce"]').value);
				
				var xhr = new XMLHttpRequest();
				var ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxurl) ? themeData.ajaxurl : ((typeof ajaxurl !== 'undefined') ? ajaxurl : '/wp-admin/admin-ajax.php');
				xhr.open('POST', ajaxUrl, true);
				
				xhr.onload = function() {
					if (xhr.status === 200) {
						try {
							var response = JSON.parse(xhr.responseText);
							if (response.success) {
								window.location.reload();
							} else {
								alert(response.data && response.data.message ? response.data.message : (response.data || 'Error removing photo.'));
							}
						} catch (e) {
							window.location.reload();
						}
					} else {
						alert('Error removing photo.');
					}
				};
				
				xhr.onerror = function() {
					alert('Error removing photo.');
				};
				
				xhr.send(formData);
			});
		}
	});
})();

// Menu and auth functionality
(function() {
	document.addEventListener('DOMContentLoaded', function() {
		// Check if themeData is available
		if (typeof themeData === 'undefined') {
			return;
		}
		
		const isLoggedIn = themeData.isLoggedIn;
		const loginUrl = themeData.loginUrl;
		const logoutUrl = themeData.logoutUrl;
		const avatarHtml = themeData.avatarHtml;
		
		// Handle auth links (#auth-link)
		const links = document.querySelectorAll('a[href="#auth-link"]');

		links.forEach(function(a) {
			// Set href
			a.setAttribute('href', isLoggedIn ? logoutUrl : loginUrl);
			
			const newText = isLoggedIn ? 'Log out' : 'Log in';
			
			// Find existing structure
			const div = a.querySelector('div');
			const span = div ? div.querySelector('span') : a.querySelector('span');
			
			if (div && span) {
				// Structure exists with div > span, just update text
				span.textContent = newText;
			} else if (span) {
				// Only span exists, update text
				span.textContent = newText;
			} else if (div) {
				// Only div exists, add span inside
				const spanClass = div.getAttribute('data-span-class') || '';
				div.innerHTML = '<span' + (spanClass ? ' class="' + spanClass + '"' : '') + '>' + newText + '</span>';
			} else {
				// No structure, create div and span preserving any existing classes on link
				const linkClasses = a.className ? ' class="' + a.className + '"' : '';
				const divClass = a.getAttribute('data-div-class') || '';
				const spanClass = a.getAttribute('data-span-class') || '';
				a.innerHTML = '<div' + (divClass ? ' class="' + divClass + '"' : '') + '><span' + (spanClass ? ' class="' + spanClass + '"' : '') + '>' + newText + '</span></div>';
			}

			a.addEventListener('click', function(e) {
				e.preventDefault();
				window.location.href = isLoggedIn ? logoutUrl : loginUrl;
			}, true); 
		});
		
		// Handle user avatar elements (by class .user-avatar)
		const userAvatarElements = document.querySelectorAll('.user-avatar');
		
		userAvatarElements.forEach(function(element) {
			if (isLoggedIn && avatarHtml) {
				// Get custom link from data-href attribute or existing href, default to /dashboard/profile/
				const customHref = element.getAttribute('data-href');
				const existingHref = element.tagName === 'A' ? element.getAttribute('href') : null;
				const defaultHref = '/dashboard/profile/';
				const targetHref = customHref || existingHref || defaultHref;
				
				// If element is already a link, replace content and set href
				if (element.tagName === 'A') {
					element.innerHTML = avatarHtml;
					element.setAttribute('href', targetHref);
					// Add menu item attributes
					element.setAttribute('tabindex', '-1');
					element.setAttribute('role', 'link');
				} else {
					// For menu items (div), create <a> tag inside like other menu items
					const link = document.createElement('a');
					link.setAttribute('href', targetHref);
					link.setAttribute('tabindex', '-1');
					link.setAttribute('role', 'link');
					link.innerHTML = avatarHtml;
					
					// Replace element content with link (like register-btn structure)
					element.innerHTML = '';
					element.appendChild(link);
				}
			} else {
				// User not logged in - hide element
				element.style.display = 'none';
			}
		});
		
		// Add active class to current menu item (DiviMenus Flex)
		// Only mark the most specific (longest) matching path as active
		const currentPath = window.location.pathname;
		const menuLinks = document.querySelectorAll('.dd-menu-flex-item a[href]');
		
		// First, collect all matching links with their paths
		const matchingLinks = [];
		
		menuLinks.forEach(function(link) {
			const linkHref = link.getAttribute('href');
			if (linkHref) {
				// Skip auth buttons (log out, log in) and register button
				const flexItem = link.closest('.et_pb_divimenus_flex_item');
				if (flexItem) {
					if (flexItem.classList.contains('auth-btn') || 
							flexItem.classList.contains('register-btn') ||
							linkHref.includes('action=custom_logout') ||
							linkHref.includes('#auth-link')) {
						return; // Skip this link
					}
				}
				
				// Remove domain and query string, get just the path
				const linkPath = new URL(linkHref, window.location.origin).pathname;
				
				// Normalize paths (remove trailing slashes for comparison)
				const normalizedCurrent = currentPath.replace(/\/$/, '') || '/';
				const normalizedLink = linkPath.replace(/\/$/, '') || '/';
				
				// Check if current path matches or starts with link path
				if (normalizedCurrent === normalizedLink || 
						(normalizedLink !== '/' && normalizedCurrent.startsWith(normalizedLink + '/'))) {
					matchingLinks.push({
						link: link,
						path: normalizedLink,
						pathLength: normalizedLink.split('/').length,
						menuItem: link.closest('.dd-menu-flex-item'),
						flexItem: flexItem
					});
				}
			}
		});
		
		// If we have matching links, find the most specific one (longest path)
		if (matchingLinks.length > 0) {
			// Sort by path length (longest first)
			matchingLinks.sort(function(a, b) {
				return b.pathLength - a.pathLength;
			});
			
			// Get the most specific (first in sorted array)
			const mostSpecific = matchingLinks[0];
			
			// Add active class only to the most specific match
			if (mostSpecific.menuItem) {
				mostSpecific.menuItem.classList.add('current-menu-item', 'active');
			}
			
			if (mostSpecific.flexItem) {
				mostSpecific.flexItem.classList.add('current-menu-item', 'active');
			}
		}
	});
})();



(function() {
    'use strict';
    
    /**
     * Function to add classes to TOC elements
     */
    function updateTOCClasses(survey, containerId) {
        if (!survey || !survey.pages) return;
        
        // Find the TOC container - try multiple possible selectors
        var containerSelector = containerId ? '#surveyContainer-' + containerId : '.wp-sjs-plugin';
        var tocContainer = document.querySelector(containerSelector + ' .sv-list') || 
                          document.querySelector(containerSelector + ' .sv-list__container') ||
                          document.querySelector(containerSelector + ' .sv-list-view') ||
                          document.querySelector('.sv-list');
        
        if (!tocContainer) {
            // Try to find TOC in the survey element itself
            var surveyElement = containerId ? document.querySelector('#surveyElement-' + containerId) : null;
            if (surveyElement) {
                tocContainer = surveyElement.querySelector('.sv-list') || 
                              surveyElement.querySelector('.sv-list__container') ||
                              surveyElement.querySelector('.sv-list-view');
            }
        }
        
        if (!tocContainer) return;
        
        var currentPageNo = survey.currentPageNo || 0;
        var tocItems = tocContainer.querySelectorAll('.sv-list__item') || 
                      tocContainer.querySelectorAll('li') ||
                      tocContainer.querySelectorAll('[data-page-index]');
        
        if (tocItems.length === 0) return;
        
        tocItems.forEach(function(item, index) {
            // Remove previous status classes
            item.classList.remove('sv-list__item--current');
            item.classList.remove('sv-list__item--completed');
            item.classList.remove('sv-list__item--pending');
            item.classList.remove('sv-list__item--visited');
            
            // Add classes depending on the status
            if (index < currentPageNo) {
                // Completed pages
                item.classList.add('sv-list__item--completed');
                item.classList.add('sv-list__item--visited');
            } else if (index === currentPageNo) {
                // Current page
                item.classList.add('sv-list__item--current');
                item.classList.add('sv-list__item--visited');
            } else {
                // Future pages
                item.classList.add('sv-list__item--pending');
            }
        });
    }
    
    /**
     * Save survey progress to server
     */
    function saveSurveyProgress(survey, surveyId) {
        if (!survey || !surveyId) return;
        
        var progressData = JSON.stringify({
            data: survey.data,
            currentPageNo: survey.currentPageNo
        });
        
        // Get stakeholder_group and country_group values from survey.data
        var stakeholderGroup = '';
        var countryGroup = '';
        
        if (survey && survey.data) {
            if (survey.data.stakeholder_group) {
                if (Array.isArray(survey.data.stakeholder_group)) {
                    stakeholderGroup = survey.data.stakeholder_group.join(',');
                } else {
                    stakeholderGroup = survey.data.stakeholder_group;
                }
            }
            if (survey.data.country_group) {
                countryGroup = survey.data.country_group;
            }
        }
        
        // Also try to get values directly from DOM if not found in survey.data
        var containerSelector = surveyId ? '#surveyContainer-' + surveyId : '.wp-sjs-plugin';
        var container = document.querySelector(containerSelector);
        
        if (!countryGroup && container) {
            var countryGroupElement = container.querySelector('[data-name="country_group"]');
            if (countryGroupElement) {
                var checkedRadio = countryGroupElement.querySelector('input[type="radio"]:checked');
                if (checkedRadio) {
                    countryGroup = checkedRadio.value || checkedRadio.getAttribute('value') || '';
                    // Try to get from label if value is empty
                    if (!countryGroup) {
                        var label = checkedRadio.closest('label') || countryGroupElement.querySelector('label[for="' + checkedRadio.id + '"]');
                        if (label) {
                            var labelText = label.textContent.trim();
                            labelText = labelText.replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                            if (labelText) {
                                countryGroup = labelText;
                            }
                        }
                    }
                    // Update survey.data if we found a value
                    if (countryGroup && survey && survey.data) {
                        survey.data.country_group = countryGroup;
                    }
                }
            }
        }
        
        var ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxurl) 
            ? themeData.ajaxurl 
            : ((typeof ajaxurl !== 'undefined') ? ajaxurl : '/wp-admin/admin-ajax.php');
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'surveyjs_save_progress',
                surveyId: surveyId,
                progressData: progressData,
                stakeholder_group: stakeholderGroup,
                country_group: countryGroup,
                nonce: (typeof themeData !== 'undefined' && themeData.progressSaveNonce) 
                    ? themeData.progressSaveNonce 
                    : ''
            },
            success: function(response) {
                // Progress saved silently
            },
            error: function() {
                // Fail silently - don't interrupt user experience
            }
        });
    }
    
    /**
     * Load survey progress from server
     */
    function loadSurveyProgress(survey, surveyId, callback) {
        if (!survey || !surveyId) {
            if (callback) callback(null, null, null);
            return;
        }
        
        var ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxurl) 
            ? themeData.ajaxurl 
            : ((typeof ajaxurl !== 'undefined') ? ajaxurl : '/wp-admin/admin-ajax.php');
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'surveyjs_load_progress',
                surveyId: surveyId,
                nonce: (typeof themeData !== 'undefined' && themeData.progressLoadNonce) 
                    ? themeData.progressLoadNonce 
                    : ''
            },
            success: function(response) {
                if (response.success && response.data && response.data.progressData) {
                    try {
                        var progress = JSON.parse(response.data.progressData);
                        var stakeholderGroup = response.data.stakeholder_group || null;
                        var countryGroup = response.data.country_group || null;
                        if (callback) callback(progress, stakeholderGroup, countryGroup);
                    } catch (e) {
                        if (callback) callback(null, null, null);
                    }
                } else {
                    if (callback) callback(null, null, null);
                }
            },
            error: function() {
                if (callback) callback(null, null, null);
            }
        });
    }
    
    /**
     * Clear survey progress (when survey is completed)
     */
    function clearSurveyProgress(surveyId) {
        if (!surveyId) return;
        
        var ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxurl) 
            ? themeData.ajaxurl 
            : ((typeof ajaxurl !== 'undefined') ? ajaxurl : '/wp-admin/admin-ajax.php');
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'surveyjs_clear_progress',
                surveyId: surveyId,
                nonce: (typeof themeData !== 'undefined' && themeData.progressClearNonce) 
                    ? themeData.progressClearNonce 
                    : ''
            }
        });
    }
    
    /**
     * Add or update "Save and Exit" button in survey navigation
     */
    function updateSaveAndExitButton(survey, surveyId) {
        if (!survey || !survey.pages) return;
        
        var containerSelector = surveyId ? '#surveyContainer-' + surveyId : '.wp-sjs-plugin';
        var container = document.querySelector(containerSelector);
        if (!container) return;
        
        var currentPageNo = survey.currentPageNo || 0;
        var totalPages = survey.pages.length;
        
        // Show button only on intermediate pages (not first, not last)
        var shouldShowButton = totalPages > 2 && currentPageNo > 0 && currentPageNo < totalPages - 1;
        
        // Find navigation container - try multiple selectors
        var navContainer = container.querySelector('.sd-body__navigation') ||
                          container.querySelector('.sv-footer') || 
                          container.querySelector('.sv-body__footer') ||
                          container.querySelector('.sd-body__footer') ||
                          container.querySelector('[class*="navigation"]') ||
                          container.querySelector('[class*="footer"]');
        
        // If still not found, try to find by looking for navigation buttons
        if (!navContainer) {
            var navButtons = container.querySelectorAll('.sd-btn');
            if (navButtons.length > 0) {
                navContainer = navButtons[0].parentElement;
            }
        }
        
        if (!navContainer) {
            // Try one more time with a delay (navigation might render later)
            setTimeout(function() {
                updateSaveAndExitButton(survey, surveyId);
            }, 200);
            return;
        }
        
        // Find or create button
        var buttonId = 'survey-save-exit-btn-' + (surveyId || 'default');
        var existingButton = document.getElementById(buttonId);
        
        // If button exists but is not in navContainer, remove it first (might be orphaned)
        if (existingButton && existingButton.parentNode !== navContainer) {
            existingButton.remove();
            existingButton = null;
        }
        
        if (shouldShowButton) {
            if (!existingButton) {
                // Create button
                var button = document.createElement('button');
                button.id = buttonId;
                button.className = 'sd-btn survey-save-exit-btn';
                button.textContent = 'Save and Exit';
                button.type = 'button';
                
                // Add click handler
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Save progress immediately
                    saveSurveyProgress(survey, surveyId);
                    
                    // Get home URL from themeData or use default
                    var homeUrl = (typeof themeData !== 'undefined' && themeData.homeUrl) 
                        ? themeData.homeUrl 
                        : '/';
                    
                    // Small delay to ensure save completes, then redirect
                    setTimeout(function() {
                        window.location.href = homeUrl;
                    }, 300);
                });
                
                // Insert button safely - use prepend if available, otherwise append
                // CSS order: -1 will position it correctly
                try {
                    if (navContainer.prepend) {
                        // Modern browsers support prepend
                        navContainer.prepend(button);
                    } else {
                        // Fallback for older browsers - append and let CSS handle positioning
                        navContainer.appendChild(button);
                    }
                } catch (e) {
                    // If prepend/appendChild fails, try insertBefore as last resort
                    console.warn('Failed to add Save and Exit button:', e);
                    if (navContainer.firstChild) {
                        try {
                            navContainer.insertBefore(button, navContainer.firstChild);
                        } catch (e2) {
                            // Last resort - just append
                            navContainer.appendChild(button);
                        }
                    } else {
                        navContainer.appendChild(button);
                    }
                }
            } else {
                // Show existing button
                existingButton.style.display = '';
            }
        } else {
            // Hide button if on first or last page
            if (existingButton) {
                existingButton.style.display = 'none';
            }
        }
    }
    
    /**
     * Track checkbox/radio changes in specific survey elements by data-name
     */
    function trackCheckboxChangesForGroup(survey, surveyId, groupName, inputType) {
        if (!survey || !groupName) return;
        
        // Default input type - can be 'checkbox', 'radio', or 'both'
        inputType = inputType || 'checkbox';
        
        var containerSelector = surveyId ? '#surveyContainer-' + surveyId : '.wp-sjs-plugin';
        var container = document.querySelector(containerSelector);
        if (!container) return;
        
        // Find element with specified data-name
        var groupElement = container.querySelector('[data-name="' + groupName + '"]');
        if (!groupElement) return;
        
        // Use a unique identifier to avoid duplicate listeners
        var trackingId = groupName + '-tracking-' + (surveyId || 'default');
        
        // Remove old listener if exists (in case element was re-rendered)
        if (groupElement[trackingId + '_handler']) {
            groupElement.removeEventListener('change', groupElement[trackingId + '_handler'], true);
        }
        
        // Function to get selected values (for checkboxes - array, for radio - single value)
        function getSelectedValues() {
            var selected = [];
            var selector = '';
            
            if (inputType === 'checkbox') {
                selector = 'input[type="checkbox"]';
            } else if (inputType === 'radio') {
                selector = 'input[type="radio"]';
            } else {
                // Both types
                selector = 'input[type="checkbox"], input[type="radio"]';
            }
            
            var inputs = groupElement.querySelectorAll(selector);
            inputs.forEach(function(input) {
                if (input.checked) {
                    // Try to get value from input or label
                    var value = input.value || input.getAttribute('value') || '';
                    var label = input.closest('label') || 
                               groupElement.querySelector('label[for="' + input.id + '"]');
                    if (label) {
                        var labelText = label.textContent.trim();
                        // Remove checkbox/radio symbols and trim
                        labelText = labelText.replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                        if (labelText) {
                            value = value || labelText;
                        }
                    }
                    if (value) {
                        selected.push(value);
                    }
                }
            });
            
            // For radio buttons, return single value instead of array
            if (inputType === 'radio' && selected.length > 0) {
                return selected[0];
            }
            
            return selected;
        }
        
        // Create handler function
        var changeHandler = function(e) {
            var isCheckbox = e.target.type === 'checkbox';
            var isRadio = e.target.type === 'radio';
            
            // Check if this input type should be tracked
            var shouldTrack = false;
            if (inputType === 'checkbox' && isCheckbox) {
                shouldTrack = true;
            } else if (inputType === 'radio' && isRadio) {
                shouldTrack = true;
            } else if (inputType === 'both' && (isCheckbox || isRadio)) {
                shouldTrack = true;
            }
            
            if (shouldTrack && groupElement.contains(e.target)) {
                var selectedValues = getSelectedValues();
                var action = e.target.checked ? 'selected' : 'unselected';
                var value = e.target.value || '';
                
                // Try to get label text
                var label = e.target.closest('label') || 
                           groupElement.querySelector('label[for="' + e.target.id + '"]');
                if (label) {
                    var labelText = label.textContent.trim();
                    labelText = labelText.replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                    if (labelText && !value) {
                        value = labelText;
                    }
                }
                
                // Also try to get from SurveyJS data if available
                if (survey && survey.data && survey.data[groupName]) {
                    var surveyValue = survey.data[groupName];
                    if (Array.isArray(surveyValue) && surveyValue.length > 0) {
                        // SurveyJS stores checkbox values as array
                        if (!value && surveyValue.indexOf(e.target.value) !== -1) {
                            value = e.target.value;
                        }
                    } else if (typeof surveyValue === 'string' && surveyValue === e.target.value) {
                        // SurveyJS stores radio value as string
                        if (!value) {
                            value = e.target.value;
                        }
                    }
                }
                
                if (!value) {
                    value = 'Unknown';
                }
                
                // Format group name for console log (capitalize first letter, replace underscore)
                var displayName = groupName.replace(/_/g, ' ').replace(/\b\w/g, function(l) {
                    return l.toUpperCase();
                });
                
            }
        };
        
        // Store handler reference for later removal
        groupElement[trackingId + '_handler'] = changeHandler;
        
        // Use event delegation - listen on the container for input changes
        groupElement.addEventListener('change', changeHandler, true); // Use capture phase to catch events early
    }
    
    /**
     * Track checkbox/radio changes in specific survey elements
     */
    function trackCheckboxChanges(survey, surveyId) {
        // Track stakeholder_group (checkboxes)
        trackCheckboxChangesForGroup(survey, surveyId, 'stakeholder_group', 'checkbox');
        // Track country_group (radio buttons)
        trackCheckboxChangesForGroup(survey, surveyId, 'country_group', 'radio');
    }
    
    /**
     * Auto-select profile values in survey inputs
     * This function automatically selects values from user profile in survey blocks
     */
    function autoSelectProfileValues(survey, surveyId) {
        // Check if themeData exists and user is logged in
        if (typeof themeData === 'undefined' || !themeData.isLoggedIn || !themeData.userProfile) {
            return;
        }
        
        // Prevent multiple auto-selections (but allow retries if blocks not found)
        var autoSelectKey = 'profileAutoSelected_' + (surveyId || 'default');
        var retryKey = 'profileAutoSelectRetries_' + (surveyId || 'default');
        var successKey = 'profileAutoSelectSuccess_' + (surveyId || 'default');
        
        // Count retries
        if (!survey[retryKey]) {
            survey[retryKey] = 0;
        }
        survey[retryKey]++;
        
        // Only skip if already successfully selected (not just attempted)
        if (survey && survey[successKey]) {
            return;
        }
        
        var userDemographic = themeData.userProfile.demographic || '';
        var userCountry = themeData.userProfile.country || '';
        
        // Check if we should update from profile
        // Simple logic: compare profile values with survey values
        // If they don't match, update from profile
        // If they match, skip (no need to update)
        var alreadyUpdatedFromProfile = survey && survey._profileValuesUpdated;
        
        // Get current survey values
        var surveyStakeholder = survey && survey.data && survey.data.stakeholder_group;
        var surveyCountry = survey && survey.data && survey.data.country_group;
        
        // Normalize values for comparison
        var surveyStakeholderArray = Array.isArray(surveyStakeholder) ? surveyStakeholder : (surveyStakeholder ? [surveyStakeholder] : []);
        var profileStakeholderArray = userDemographic ? userDemographic.split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v.length > 0; }) : [];
        
        // Compare stakeholder values (check if arrays contain same values, order doesn't matter)
        // If survey has no values but profile has values, we should update (first load)
        var stakeholderMatch = false;
        if (profileStakeholderArray.length === 0 && surveyStakeholderArray.length === 0) {
            stakeholderMatch = true; // Both empty - no need to update
        } else if (profileStakeholderArray.length > 0 && surveyStakeholderArray.length === 0) {
            stakeholderMatch = false; // Profile has values, survey doesn't - should update
        } else if (profileStakeholderArray.length === surveyStakeholderArray.length && profileStakeholderArray.length > 0) {
            // Both have values - check if they match
            stakeholderMatch = profileStakeholderArray.every(function(val) {
                return surveyStakeholderArray.some(function(surveyVal) {
                    return surveyVal.toLowerCase() === val.toLowerCase() || 
                           surveyVal.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
                           val.toLowerCase().indexOf(surveyVal.toLowerCase()) !== -1;
                });
            });
        }
        
        // Compare country values
        // If survey has no value but profile has value, we should update (first load)
        var countryMatch = false;
        if (!userCountry && !surveyCountry) {
            countryMatch = true; // Both empty - no need to update
        } else if (userCountry && !surveyCountry) {
            countryMatch = false; // Profile has value, survey doesn't - should update
        } else if (userCountry && surveyCountry) {
            var userCountryLower = userCountry.toLowerCase();
            var surveyCountryLower = surveyCountry.toLowerCase();
            // Check exact match or if country code is in the survey value (e.g., "Austria (AT)" contains "AT")
            countryMatch = userCountryLower === surveyCountryLower || 
                          surveyCountryLower.indexOf('(' + userCountry + ')') !== -1 ||
                          surveyCountryLower.indexOf(userCountryLower) !== -1;
        }
        
        // Determine if we should update
        // Update if: not already updated AND profile has values AND values don't match (or survey is empty)
        var shouldUpdateStakeholder = !alreadyUpdatedFromProfile && userDemographic && !stakeholderMatch;
        var shouldUpdateCountry = !alreadyUpdatedFromProfile && userCountry && !countryMatch;
        
        // Clear values if they match (no need to update)
        if (!shouldUpdateStakeholder) {
            userDemographic = '';
        }
        
        if (!shouldUpdateCountry) {
            userCountry = '';
        }
        
        // If no values to auto-select, mark as done and return
        if (!userDemographic && !userCountry) {
            if (survey) {
                survey[autoSelectKey] = true;
            }
            return;
        }
        
        var containerSelector = surveyId ? '#surveyContainer-' + surveyId : '.wp-sjs-plugin';
        var container = document.querySelector(containerSelector);
        
        if (!container) {
            // Try alternative selectors
            var altSelectors = [
                '.wp-sjs-plugin',
                '[id^="surveyContainer-"]',
                '.sv-root',
                '.sv_main'
            ];
            
            for (var i = 0; i < altSelectors.length; i++) {
                container = document.querySelector(altSelectors[i]);
                if (container) {
                    break;
                }
            }
            
            if (!container) {
                // Try to find all possible survey containers
                var allContainers = document.querySelectorAll('.wp-sjs-plugin, [id^="surveyContainer-"], .sv-root, .sv_main');
                if (allContainers.length > 0) {
                    container = allContainers[0];
                } else {
                    return;
                }
            }
        }
        
        // Track selection results
        var selectionResults = {
            stakeholderFound: false,
            stakeholderSelected: false,
            countryFound: false,
            countrySelected: false
        };
        
        // Auto-select stakeholder_group (checkboxes) from demographic
        if (userDemographic) {
            // Try multiple selectors
            var stakeholderGroup = container.querySelector('[data-name="stakeholder_group"]');
            if (!stakeholderGroup) {
                // Try case-insensitive search
                var allDataNameElements = container.querySelectorAll('[data-name]');
                for (var i = 0; i < allDataNameElements.length; i++) {
                    var dataName = allDataNameElements[i].getAttribute('data-name');
                    if (dataName && dataName.toLowerCase() === 'stakeholder_group') {
                        stakeholderGroup = allDataNameElements[i];
                        break;
                    }
                }
            }
            
            if (stakeholderGroup) {
                selectionResults.stakeholderFound = true;
                // Split demographic by comma (it's stored as "value1,value2")
                var demographicValues = userDemographic.split(',').map(function(v) {
                    return v.trim();
                }).filter(function(v) {
                    return v.length > 0;
                });
                
                if (demographicValues.length > 0) {
                    var selectedValues = [];
                    var checkboxes = stakeholderGroup.querySelectorAll('input[type="checkbox"]');
                    
                    checkboxes.forEach(function(checkbox) {
                        var checkboxValue = checkbox.value || '';
                        var label = checkbox.closest('label') || 
                                   stakeholderGroup.querySelector('label[for="' + checkbox.id + '"]');
                        var labelText = '';
                        if (label) {
                            labelText = label.textContent.trim();
                            labelText = labelText.replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                        }
                        
                        // Check if this checkbox matches any demographic value
                        var shouldSelect = demographicValues.some(function(demoValue) {
                            // Compare by value, label text, or case-insensitive match
                            return checkboxValue.toLowerCase() === demoValue.toLowerCase() ||
                                   labelText.toLowerCase() === demoValue.toLowerCase() ||
                                   demoValue.toLowerCase().indexOf(checkboxValue.toLowerCase()) !== -1 ||
                                   checkboxValue.toLowerCase().indexOf(demoValue.toLowerCase()) !== -1;
                        });
                        
                        if (shouldSelect && !checkbox.checked) {
                            checkbox.checked = true;
                            // Store selected value
                            if (checkboxValue) {
                                selectedValues.push(checkboxValue);
                            } else if (labelText) {
                                selectedValues.push(labelText);
                            }
                            // Trigger change event to update SurveyJS data
                            var changeEvent = new Event('change', { bubbles: true });
                            checkbox.dispatchEvent(changeEvent);
                        }
                    });
                    
                    // Update survey.data if SurveyJS is available
                    if (survey && survey.setValue && selectedValues.length > 0) {
                        survey.setValue('stakeholder_group', selectedValues);
                        selectionResults.stakeholderSelected = true;
                    } else if (survey && survey.data && selectedValues.length > 0) {
                        survey.data['stakeholder_group'] = selectedValues;
                        selectionResults.stakeholderSelected = true;
                    }
                }
            }
        }
        
        // Auto-select country_group (radio) from country
        if (userCountry) {
            // Try multiple selectors
            var countryGroup = container.querySelector('[data-name="country_group"]');
            if (!countryGroup) {
                // Try case-insensitive search
                var allDataNameElements = container.querySelectorAll('[data-name]');
                for (var i = 0; i < allDataNameElements.length; i++) {
                    var dataName = allDataNameElements[i].getAttribute('data-name');
                    if (dataName && dataName.toLowerCase() === 'country_group') {
                        countryGroup = allDataNameElements[i];
                        break;
                    }
                }
            }
            
            if (countryGroup) {
                selectionResults.countryFound = true;
                
                // Check if country is already correctly selected
                var currentSelectedRadio = countryGroup.querySelector('input[type="radio"]:checked');
                var currentSelectedValue = null;
                if (currentSelectedRadio) {
                    currentSelectedValue = currentSelectedRadio.value || '';
                    var currentLabel = currentSelectedRadio.closest('label') || 
                                     countryGroup.querySelector('label[for="' + currentSelectedRadio.id + '"]');
                    if (currentLabel) {
                        var currentLabelText = currentLabel.textContent.trim().replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                        if (!currentSelectedValue && currentLabelText) {
                            currentSelectedValue = currentLabelText;
                        }
                    }
                }
                
                // Check if current selection matches profile country
                var currentMatchesProfile = false;
                if (currentSelectedValue) {
                    var currentValueLower = currentSelectedValue.toLowerCase();
                    var userCountryLower = userCountry.toLowerCase();
                    // Check exact match
                    if (currentValueLower === userCountryLower) {
                        currentMatchesProfile = true;
                    } else {
                        // Check if country code is in the value (e.g., "Belgium (BE)" contains "BE")
                        var codeMatch = currentValueLower.match(/\(([a-z]{2})\)/);
                        if (codeMatch && codeMatch[1] === userCountryLower) {
                            currentMatchesProfile = true;
                        }
                    }
                }
                
                // Only proceed if current selection doesn't match profile
                if (!currentMatchesProfile) {
                    var selectedValue = null;
                    var radios = countryGroup.querySelectorAll('input[type="radio"]');
                    
                    // Find the best matching radio button
                    radios.forEach(function(radio) {
                        var radioValue = radio.value || '';
                        var label = radio.closest('label') || 
                                   countryGroup.querySelector('label[for="' + radio.id + '"]');
                        var labelText = '';
                        if (label) {
                            labelText = label.textContent.trim();
                            labelText = labelText.replace(/☑|☐|✓|✔|✗|✘|●|○|◉/g, '').trim();
                        }
                        
                        // Check if this radio matches country value
                        // Priority: exact value match > country code in parentheses > partial text match
                        var shouldSelect = false;
                        var matchPriority = 0; // Higher priority = better match
                        
                        // Priority 3: Exact value match
                        if (radioValue.toLowerCase() === userCountry.toLowerCase()) {
                            shouldSelect = true;
                            matchPriority = 3;
                        } else if (labelText) {
                            // Priority 2: Country code in parentheses (e.g., "Belgium (BE)")
                            var countryCodeMatch = labelText.match(/\(([A-Z]{2})\)/);
                            if (countryCodeMatch && countryCodeMatch[1].toLowerCase() === userCountry.toLowerCase()) {
                                shouldSelect = true;
                                matchPriority = 2;
                            } else {
                                // Priority 1: Partial text match (less reliable)
                                var labelLower = labelText.toLowerCase();
                                var userCountryLower = userCountry.toLowerCase();
                                if (labelLower === userCountryLower || 
                                    labelLower.indexOf(userCountryLower) !== -1 ||
                                    userCountryLower.indexOf(labelLower) !== -1) {
                                    // Only use partial match if no better match found
                                    if (!selectedValue || matchPriority < 1) {
                                        shouldSelect = true;
                                        matchPriority = 1;
                                    }
                                }
                            }
                        }
                        
                        // Select this radio if it's a better match than previously found
                        if (shouldSelect && (!selectedValue || matchPriority > (selectedValue.matchPriority || 0))) {
                            // Uncheck previous selection if any
                            if (selectedValue && selectedValue.radio) {
                                selectedValue.radio.checked = false;
                            }
                            radio.checked = true;
                            selectedValue = {
                                value: radioValue || labelText,
                                radio: radio,
                                matchPriority: matchPriority
                            };
                        }
                    });
                    
                    // Trigger change event only once for the selected radio
                    if (selectedValue && selectedValue.radio) {
                        var changeEvent = new Event('change', { bubbles: true });
                        selectedValue.radio.dispatchEvent(changeEvent);
                        selectedValue = selectedValue.value; // Store just the value for later use
                    } else {
                        selectedValue = null;
                    }
                } else {
                    // Current selection already matches profile - no need to change
                    var alreadySelectedRadio = countryGroup.querySelector('input[type="radio"]:checked');
                    if (alreadySelectedRadio) {
                        selectedValue = alreadySelectedRadio.value || currentSelectedValue;
                        selectionResults.countrySelected = true; // Mark as already selected correctly
                    }
                }
                
                // Update survey.data if SurveyJS is available
                // Note: selectedValue might be a string (if already matched) or null (if no change needed)
                var countryValueToSet = null;
                if (selectedValue) {
                    if (typeof selectedValue === 'string') {
                        countryValueToSet = selectedValue;
                    } else if (selectedValue.value) {
                        countryValueToSet = selectedValue.value;
                    }
                }
                
                if (countryValueToSet && survey && survey.setValue) {
                    survey.setValue('country_group', countryValueToSet);
                    selectionResults.countrySelected = true;
                } else if (countryValueToSet && survey && survey.data) {
                    survey.data['country_group'] = countryValueToSet;
                    selectionResults.countrySelected = true;
                }
            }
        }
        
        // Check if we successfully found and selected values
        var stakeholderSuccess = !userDemographic || selectionResults.stakeholderSelected;
        var countrySuccess = !userCountry || selectionResults.countrySelected;
        
        if (stakeholderSuccess && countrySuccess) {
            // Mark as successfully completed
            if (survey) {
                survey[successKey] = true;
                survey[autoSelectKey] = true;
                // Mark that we've updated from profile (to prevent repeated updates)
                if ((shouldUpdateStakeholder || shouldUpdateCountry) && (userDemographic || userCountry)) {
                    survey._profileValuesUpdated = true;
                }
            }
        } else {
            // Not all blocks found yet, allow retries
            // Stop retrying after 15 attempts
            if (survey[retryKey] >= 15) {
                if (survey) {
                    survey[autoSelectKey] = true; // Stop retrying
                }
            }
        }
    }
    
    /**
     * Initialize tracking for a specific survey
     */
    function initSurveyTracking(survey, surveyId) {
        if (!survey) return;
        
        // Check if Survey.Model exists and survey is an instance
        if (typeof Survey !== 'undefined' && Survey.Model && !(survey instanceof Survey.Model)) {
            return;
        }
        
        // Prevent double initialization
        if (survey._tocTrackingInitialized) return;
        survey._tocTrackingInitialized = true;
        
        // Add event handlers
        if (survey.onCurrentPageChanged) {
            survey.onCurrentPageChanged.add(function(sender) {
                updateTOCClasses(sender, surveyId);
                updateSaveAndExitButton(sender, surveyId);
                // Track checkbox changes after page change
                setTimeout(function() {
                    trackCheckboxChanges(sender, surveyId);
                }, 200);
            });
        }
        
        if (survey.onPageVisibleChanged) {
            survey.onPageVisibleChanged.add(function(sender, options) {
                updateTOCClasses(sender, surveyId);
                updateSaveAndExitButton(sender, surveyId);
                // Track checkbox changes after page becomes visible
                setTimeout(function() {
                    trackCheckboxChanges(sender, surveyId);
                }, 200);
            });
        }
        
        if (survey.onAfterRenderPage) {
            survey.onAfterRenderPage.add(function(sender) {
                // Small delay to allow TOC to render
                setTimeout(function() {
                    updateTOCClasses(sender, surveyId);
                    updateSaveAndExitButton(sender, surveyId);
                    // Track checkbox changes after page render
                    trackCheckboxChanges(sender, surveyId);
                    // Auto-select profile values if not already set
                    autoSelectProfileValues(sender, surveyId);
                }, 100);
            });
        }
        
        // Add handler for after each question is rendered
        if (survey.onAfterRenderQuestion) {
            survey.onAfterRenderQuestion.add(function(sender, options) {
                // Check if this is one of our target questions
                if (options && options.question) {
                    var questionName = options.question.name || '';
                    if (questionName === 'stakeholder_group' || questionName === 'country_group') {
                        setTimeout(function() {
                            autoSelectProfileValues(sender, surveyId);
                        }, 100);
                    }
                }
            });
        }
        
        // Use MutationObserver to watch for elements with data-name appearing
        if (typeof MutationObserver !== 'undefined') {
            var containerSelector = surveyId ? '#surveyContainer-' + surveyId : '.wp-sjs-plugin';
            var observerContainer = document.querySelector(containerSelector);
            
            if (observerContainer) {
                var observer = new MutationObserver(function(mutations) {
                    var shouldCheck = false;
                    mutations.forEach(function(mutation) {
                        if (mutation.addedNodes.length > 0) {
                            for (var i = 0; i < mutation.addedNodes.length; i++) {
                                var node = mutation.addedNodes[i];
                                if (node.nodeType === 1) { // Element node
                                    if (node.getAttribute && (node.getAttribute('data-name') === 'stakeholder_group' || 
                                        node.getAttribute('data-name') === 'country_group')) {
                                        shouldCheck = true;
                                        break;
                                    }
                                    // Check children
                                    if (node.querySelector && (node.querySelector('[data-name="stakeholder_group"]') || 
                                        node.querySelector('[data-name="country_group"]'))) {
                                        shouldCheck = true;
                                        break;
                                    }
                                }
                            }
                        }
                    });
                    
                    if (shouldCheck) {
                        setTimeout(function() {
                            autoSelectProfileValues(survey, surveyId);
                        }, 200);
                    }
                });
                
                observer.observe(observerContainer, {
                    childList: true,
                    subtree: true
                });
                
                // Store observer reference to prevent multiple observers
                if (!survey._profileAutoSelectObserver) {
                    survey._profileAutoSelectObserver = observer;
                }
            }
        }
        
        // Initial update with multiple attempts (TOC might render later)
        // Also retry auto-select multiple times as questions may render progressively
        setTimeout(function() {
            updateTOCClasses(survey, surveyId);
            updateSaveAndExitButton(survey, surveyId);
            trackCheckboxChanges(survey, surveyId);
            autoSelectProfileValues(survey, surveyId);
        }, 500);
        
        setTimeout(function() {
            updateTOCClasses(survey, surveyId);
            updateSaveAndExitButton(survey, surveyId);
            trackCheckboxChanges(survey, surveyId);
            autoSelectProfileValues(survey, surveyId);
        }, 1000);
        
        setTimeout(function() {
            updateTOCClasses(survey, surveyId);
            updateSaveAndExitButton(survey, surveyId);
            trackCheckboxChanges(survey, surveyId);
            autoSelectProfileValues(survey, surveyId);
        }, 2000);
        
        // Additional retries for auto-select (questions may render later)
        setTimeout(function() {
            autoSelectProfileValues(survey, surveyId);
        }, 3000);
        
        setTimeout(function() {
            autoSelectProfileValues(survey, surveyId);
        }, 5000);
        
        // ============================================
        // Progress saving functionality
        // ============================================
        
        // Initialize _hasLoadedProgress as false (will be set to true only if progress is loaded)
        survey._hasLoadedProgress = false;
        survey._progressLoadCompleted = false;
        
        // Load saved progress on initialization
        loadSurveyProgress(survey, surveyId, function(progress, loadedStakeholder, loadedCountry) {
            survey._progressLoadCompleted = true;
            
            if (progress && progress.data) {
                // Restore survey data first
                survey.data = progress.data;
                
                // Check if progress has actual values for our fields
                var hasStakeholderInProgress = progress.data.stakeholder_group && progress.data.stakeholder_group.length > 0;
                var hasCountryInProgress = progress.data.country_group;
                
                // Also check loaded values from database columns and add if not in progressData
                if (!hasStakeholderInProgress && loadedStakeholder) {
                    // Restore from database column if not in progressData
                    if (!survey.data) {
                        survey.data = {};
                    }
                    survey.data.stakeholder_group = Array.isArray(loadedStakeholder.split(',')) 
                        ? loadedStakeholder.split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v.length > 0; })
                        : [loadedStakeholder.trim()].filter(function(v) { return v.length > 0; });
                    hasStakeholderInProgress = true;
                }
                
                if (!hasCountryInProgress && loadedCountry) {
                    // Restore from database column if not in progressData
                    if (!survey.data) {
                        survey.data = {};
                    }
                    survey.data.country_group = loadedCountry.trim();
                    hasCountryInProgress = true;
                }
                
                // Only mark as loaded progress if there are actual values for our fields
                // Otherwise, treat it as first load and allow profile values to be set
                if (hasStakeholderInProgress || hasCountryInProgress) {
                    survey._hasLoadedProgress = true;
                } else {
                    survey._hasLoadedProgress = false;
                }
                
                // Restore current page if available
                if (typeof progress.currentPageNo !== 'undefined' && progress.currentPageNo >= 0) {
                    survey.currentPageNo = progress.currentPageNo;
                }
                
                // Render the survey with restored data
                survey.render();
                
                // Update button after render
                setTimeout(function() {
                    updateSaveAndExitButton(survey, surveyId);
                }, 300);
            } else {
                // No saved progress - keep as false (first load)
                survey._hasLoadedProgress = false;
                // No saved progress - auto-select profile values after initial render
                if (survey.onAfterRenderSurvey) {
                    survey.onAfterRenderSurvey.add(function() {
                        setTimeout(function() {
                            autoSelectProfileValues(survey, surveyId);
                        }, 300);
                    });
                }
                // Also try after page render
                if (survey.onAfterRenderPage) {
                    survey.onAfterRenderPage.add(function() {
                        setTimeout(function() {
                            autoSelectProfileValues(survey, surveyId);
                        }, 200);
                    });
                }
                // Fallback with timeout
                setTimeout(function() {
                    autoSelectProfileValues(survey, surveyId);
                }, 1000);
            }
        });
        
        // Auto-save progress on value change (debounced)
        var saveProgressTimeout;
        survey.onValueChanged.add(function(sender, options) {
            clearTimeout(saveProgressTimeout);
            
            // Track checkbox changes when values change
            if (options && options.name === 'stakeholder_group') {
                setTimeout(function() {
                    trackCheckboxChanges(sender, surveyId);
                }, 100);
            }
            
            saveProgressTimeout = setTimeout(function() {
                saveSurveyProgress(sender, surveyId);
            }, 1000); // Save 1 second after last change
        });
        
        // Auto-save progress on page change
        if (survey.onCurrentPageChanged) {
            survey.onCurrentPageChanged.add(function(sender) {
                saveSurveyProgress(sender, surveyId);
            });
        }
        
        // Clear progress when survey is completed (but preserve stakeholder_group and country_group)
        if (survey.onComplete) {
            survey.onComplete.add(function(sender) {
                // Save final values before clearing progressData
                saveSurveyProgress(sender, surveyId);
                // Small delay to ensure save completes, then clear progressData (but keep metadata)
                setTimeout(function() {
                    clearSurveyProgress(surveyId);
                }, 500);
            });
        }
        
        // Also save progress before page unload
        window.addEventListener('beforeunload', function() {
            saveSurveyProgress(survey, surveyId);
        });
    }
    
    /**
     * Find all surveys on the page and initialize tracking
     */
    function initAllSurveys() {
        if (typeof Survey === 'undefined') return;
        
        // Find all survey containers
        var containers = document.querySelectorAll('.wp-sjs-plugin, [id^="surveyContainer-"]');
        
        containers.forEach(function(container) {
            var containerId = container.id ? container.id.replace('surveyContainer-', '') : null;
            var surveyVar = containerId ? 'survey' + containerId : null;
            
            if (surveyVar && window[surveyVar]) {
                var survey = window[surveyVar];
                // Check if it's a Survey.Model instance
                if (Survey.Model && survey instanceof Survey.Model) {
                    initSurveyTracking(survey, containerId);
                } else if (survey && typeof survey.currentPageNo !== 'undefined') {
                    // Might be a survey object even if not instanceof check works
                    initSurveyTracking(survey, containerId);
                }
            }
        });
        
        // Also find all global survey variables
        var surveyPattern = /^survey\d+$/;
        for (var key in window) {
            if (surveyPattern.test(key) && window[key]) {
                var survey = window[key];
                var surveyId = key.replace('survey', '');
                
                // Check if it's a Survey.Model instance
                if (Survey.Model && survey instanceof Survey.Model) {
                    if (!survey._tocTrackingInitialized) {
                        initSurveyTracking(survey, surveyId);
                    }
                } else if (survey && typeof survey.currentPageNo !== 'undefined' && !survey._tocTrackingInitialized) {
                    // Might be a survey object
                    initSurveyTracking(survey, surveyId);
                }
            }
        }
    }
    
    /**
     * Hook into jQuery AJAX to detect when surveys are loaded
     */
    function setupAjaxHook() {
        if (typeof jQuery === 'undefined') return;
        
        // Hook into jQuery AJAX success to detect survey initialization
        var originalAjax = jQuery.ajax;
        jQuery.ajax = function(options) {
            var originalSuccess = options.success;
            options.success = function(data) {
                if (originalSuccess) {
                    originalSuccess.apply(this, arguments);
                }
                // Check if this might be a survey JSON request
                if (data && (data.json || data.theme)) {
                    // Survey data loaded, wait a bit for initialization
                    setTimeout(function() {
                        initAllSurveys();
                    }, 500);
                }
            };
            return originalAjax.call(this, options);
        };
    }
    
    /**
     * Main initialization function
     */
    function init() {
        // Wait for SurveyJS to load
        if (typeof Survey === 'undefined') {
            var checkSurvey = setInterval(function() {
                if (typeof Survey !== 'undefined') {
                    clearInterval(checkSurvey);
                    setupAjaxHook();
                    setTimeout(initAllSurveys, 100);
                }
            }, 100);
            
            // Stop checking after 10 seconds
            setTimeout(function() {
                clearInterval(checkSurvey);
            }, 10000);
        } else {
            setupAjaxHook();
            initAllSurveys();
        }
    }
    
    // Start after DOM is loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // Also listen for dynamic survey addition events
    if (typeof jQuery !== 'undefined') {
        jQuery(document).ready(function() {
            setTimeout(init, 500);
            setTimeout(initAllSurveys, 1500);
            setTimeout(initAllSurveys, 3000);
        });
    }
    
    // MutationObserver for tracking dynamically added surveys
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            var shouldCheck = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && 
                            (node.classList && (node.classList.contains('wp-sjs-plugin') || 
                             node.id && node.id.indexOf('surveyContainer-') === 0))) {
                            shouldCheck = true;
                        }
                        // Also check for TOC elements
                        if (node.nodeType === 1 && node.querySelector && 
                            (node.querySelector('.sv-list') || node.querySelector('.sv-list__item'))) {
                            shouldCheck = true;
                        }
                    });
                }
            });
            
            if (shouldCheck && typeof Survey !== 'undefined') {
                setTimeout(initAllSurveys, 300);
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // Auto-sync username field with email for RCP registration form
    // This ensures the hidden username field is populated with email value
    function initRCPUsernameSync() {
        var registrationForm = document.getElementById('rcp_registration_form');
        if (!registrationForm) {
            return;
        }
        
        var emailField = document.getElementById('rcp_user_email');
        var usernameField = document.getElementById('rcp_user_login');
        
        if (!emailField || !usernameField) {
            return;
        }
        
        // Sync username with email when email field changes
        emailField.addEventListener('input', function() {
            if (usernameField && emailField.value) {
                usernameField.value = emailField.value;
            }
        });
        
        // Also sync on form submit to ensure it's up to date
        registrationForm.addEventListener('submit', function() {
            if (usernameField && emailField.value) {
                usernameField.value = emailField.value;
            }
        });
    }
    
    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRCPUsernameSync);
    } else {
        initRCPUsernameSync();
    }
    
})();